/* ROUGHCUT — reviews UI.
   Reads window.RC_REVIEWS (assets/rc-reviews-data.js, built from the Judge.me export)
   and renders into any element with [data-rc-reviews]:
     data-mode="wall"   → community page: summary, photo rail, filters, every 4–5★ review,
                          and a "What we're working on" tab with every 1–3★ review.
     data-mode="shelf"  → product / landing pages: reviews for the patterns named in data-groups.
   Nothing is invented here: averages are computed from every published review, good and bad. */
(function(){
  if (window.__rcReviewsUI) return; window.__rcReviewsUI = true;

  var esc = function(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); };
  var D, IMG;
  var MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  var fmtDate = function(d){ var p = (d||'').split('-'); return p.length > 1 ? MONTHS[+p[1]-1] + ' ' + p[0] : ''; };
  var img = function(file, w){ return IMG + file + '?quality=80&width=' + w; };
  var starStr = function(r){ var s=''; for (var i=1;i<=5;i++) s += i<=r ? '★' : '<span class="o">★</span>'; return s; };
  var stars = function(r){ return '<span class="rcRV__stars" aria-label="'+r+' out of 5 stars">'+starStr(r)+'</span>'; };
  var initial = function(n){ return esc((n||'?').trim().charAt(0).toUpperCase()); };
  var groupName = function(g){ return (D.groups[g] && D.groups[g][0]) || ''; };
  var groupUrl = function(g){ return (D.groups[g] && D.groups[g][1]) || ''; };
  var TICK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M12 2l2.4 2.1 3.2-.3.9 3.1 2.8 1.6-1.1 3 1.1 3-2.8 1.6-.9 3.1-3.2-.3L12 22l-2.4-2.1-3.2.3-.9-3.1L2.7 15.5l1.1-3-1.1-3 2.8-1.6.9-3.1 3.2.3z"/><path d="M8 12.2l2.6 2.6L16.2 9" fill="none" stroke="#1D1D20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function avgOf(list){ if(!list.length) return 0; var t=0; list.forEach(function(r){t+=r.r}); return t/list.length; }
  function fmtAvg(a){ return (Math.round(a*10)/10).toFixed(1); }

  /* ───────── card ───────── */
  function card(r, opts){
    opts = opts || {};
    var pics = r.p || [], th = '';
    if (pics.length){
      var show = pics.slice(0, pics.length === 1 ? 1 : 3);
      th = '<div class="rcRV__thumbs'+(pics.length===1?' one':'')+'">' + show.map(function(p, i){
        var extra = (i === 2 && pics.length > 3) ? ' class="plus" data-more="+'+(pics.length-3)+'"' : '';
        return '<span'+extra+'><img loading="lazy" decoding="async" src="'+img(p, pics.length===1?700:360)+'" alt="Build photo from '+esc(r.n)+'"></span>';
      }).join('') + '</div>';
    }
    var long = (r.b||'').length > 330;
    var pat = groupName(r.g);
    return '<button type="button" class="rcRV__card" data-rid="'+r.id+'" aria-label="Open review from '+esc(r.n)+'">'
      + '<div class="rcRV__cardTop">'+stars(r.r)+'<span class="rcRV__date">'+fmtDate(r.d)+'</span></div>'
      + (r.t ? '<p class="rcRV__title">'+esc(r.t)+'</p>' : '')
      + '<p class="rcRV__body">'+esc(r.b)+'</p>'
      + (long ? '<span class="rcRV__more">Read more</span>' : '')
      + th
      + '<div class="rcRV__by"><span class="rcRV__av" aria-hidden="true">'+initial(r.n)+'</span>'
      + '<span><b>'+esc(r.n)+'</b>'+(r.c ? '<br>'+esc(r.c) : '')+'</span>'
      + (pat && !opts.hidePattern ? '<span class="pat">'+esc(pat)+'</span>' : '')
      + '</div></button>';
  }

  /* ───────── lightbox (one, shared) ───────── */
  var LB, lbList = [], lbIdx = 0, lbReturn = null;
  function ensureLB(){
    if (LB) return LB;
    LB = document.createElement('div');
    LB.className = 'rcLB'; LB.setAttribute('role','dialog'); LB.setAttribute('aria-modal','true'); LB.setAttribute('aria-label','Review');
    LB.innerHTML = '<div class="rcLB__sheet"></div>';
    document.body.appendChild(LB);
    LB.addEventListener('click', function(e){
      if (e.target === LB || e.target.closest('.rcLB__x')) return closeLB();
      if (e.target.closest('.rcLB__nav.prev')) return showLB(lbIdx-1);
      if (e.target.closest('.rcLB__nav.next')) return showLB(lbIdx+1);
    });
    document.addEventListener('keydown', function(e){
      if (!LB.classList.contains('open')) return;
      if (e.key === 'Escape') closeLB();
      else if (e.key === 'ArrowRight' && lbList.length > 1) showLB(lbIdx+1);
      else if (e.key === 'ArrowLeft' && lbList.length > 1) showLB(lbIdx-1);
    });
    return LB;
  }
  function showLB(i){
    if (!lbList.length) return;
    lbIdx = (i + lbList.length) % lbList.length;
    var r = lbList[lbIdx], pics = r.p || [], sheet = LB.querySelector('.rcLB__sheet');
    var url = groupUrl(r.g), pat = groupName(r.g);
    var X = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
    var L = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var R = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    sheet.className = 'rcLB__sheet' + (pics.length ? '' : ' noimg');
    sheet.innerHTML =
      '<button class="rcLB__x" type="button" aria-label="Close">'+X+'</button>'
      + (lbList.length > 1 ? '<button class="rcLB__nav prev" type="button" aria-label="Previous review">'+L+'</button><button class="rcLB__nav next" type="button" aria-label="Next review">'+R+'</button>' : '')
      + (pics.length ? '<div><div class="rcLB__imgs">' + pics.map(function(p){ return '<img src="'+img(p,1200)+'" alt="Build photo from '+esc(r.n)+'" decoding="async">'; }).join('') + '</div>'
          + (pics.length > 1 ? '<div class="rcLB__dots">'+pics.map(function(_,k){return '<i'+(k?'':' class="on"')+'></i>';}).join('')+'</div>' : '') + '</div>' : '')
      + '<div class="rcLB__txt">' + stars(r.r)
      + (r.t ? '<p class="rcLB__t">'+esc(r.t)+'</p>' : '')
      + '<p class="rcLB__b">'+esc(r.b)+'</p>'
      + '<div class="rcLB__who"><span class="rcRV__av" aria-hidden="true">'+initial(r.n)+'</span><span><b>'+esc(r.n)+'</b>'+(r.c?' · '+esc(r.c):'')+'<br>'+(pat && r.g!=='shop' ? esc(pat)+' · ' : '')+fmtDate(r.d)+' · Verified buyer</span></div>'
      + (url && r.r >= 4 ? '<a class="rcLB__shop" href="'+url+'">See '+esc(pat)+' →</a>' : '')
      + '</div>';
    var strip = sheet.querySelector('.rcLB__imgs'), dots = sheet.querySelectorAll('.rcLB__dots i');
    if (strip && dots.length) strip.addEventListener('scroll', function(){
      var k = Math.round(strip.scrollLeft / strip.clientWidth);
      dots.forEach(function(d, j){ d.classList.toggle('on', j === k); });
    }, {passive:true});
    sheet.scrollTop = 0;
  }
  function openLB(list, id){
    ensureLB(); lbList = list; lbReturn = document.activeElement;
    var i = 0; list.some(function(r, k){ if (r.id === id){ i = k; return true; } });
    showLB(i);
    LB.classList.add('open'); document.body.classList.add('rcLB-lock');
    var x = LB.querySelector('.rcLB__x'); if (x) x.focus({preventScroll:true});
  }
  function closeLB(){
    LB.classList.remove('open'); document.body.classList.remove('rcLB-lock');
    if (lbReturn && lbReturn.focus) lbReturn.focus({preventScroll:true});
  }

  /* ───────── shelf (product + landing pages) ───────── */
  function shelf(el){
    /* On the pattern landing pages, sit the reviews right above the buy box. */
    var sec = el.closest('[data-rc-reviews-section]');
    var before = el.dataset.before && document.querySelector(el.dataset.before);
    if (sec && before && before.parentNode && !sec.contains(before)) {
      before.parentNode.insertBefore(sec, before);
      if (sec.closest('.rx')) { sec.classList.remove('rcRV--ink'); sec.classList.add('rcRV--paper'); }
    }
    var groups = (el.dataset.groups || '').split(',').map(function(s){return s.trim();}).filter(Boolean);
    var handle = el.dataset.handle;
    /* On a product page with no groups set, use the product's own group. */
    var own = false, everything = false;
    if (!groups.length && handle){
      if (D.handles && D.handles[handle]) { groups = [D.handles[handle]]; own = true; }
      else if (D.bundles && D.bundles[handle]) { if (D.bundles[handle] === '*') everything = true; else groups = D.bundles[handle].split(','); }
      else { (el.closest('[data-rc-reviews-section]') || el).hidden = true; return; }
    }
    if (!groups.length && !handle) everything = true;   /* not on a product, nothing set → best of everything */
    var all = everything ? D.reviews.slice() : D.reviews.filter(function(r){ return groups.indexOf(r.g) > -1; });
    var good = all.filter(function(r){ return r.r >= 4; });
    var minShow = +(el.dataset.min || 1);
    if (good.length < minShow) { (el.closest('[data-rc-reviews-section]') || el).hidden = true; return; }
    good.sort(function(a,b){ return (b.p.length?1:0) - (a.p.length?1:0) || (b.r - a.r) || (b.b.length > 60) - (a.b.length > 60) || (a.d < b.d ? 1 : -1); });
    var limit = +(el.dataset.limit || 12), list = good.slice(0, limit);
    var avg = avgOf(all), community = el.dataset.community || '/pages/community';
    var multi = !own;
    var low = all.length - good.length;
    el.innerHTML =
      '<div class="rcRV__shelfHead"><div>'
      + '<div class="rcRV__eyebrow">'+esc(el.dataset.eyebrow || 'Verified reviews')+'</div>'
      + '<h2 class="rcRV__h">'+((handle && !own && el.dataset.headingMulti) || el.dataset.heading || 'What makers <em>say.</em>')+'</h2>'
      + '</div><div class="rcRV__mini"><b>'+fmtAvg(avg)+'</b><span>'+stars(Math.round(avg))+'<br>'+all.length+' review'+(all.length===1?'':'s')+'</span></div></div>'
      + '<div class="rcRV__row">' + list.map(function(r){ return card(r, {hidePattern: !multi}); }).join('') + '</div>'
      + '<div class="rcRV__links"><a href="'+community+'#reviews">Read all '+D.meta.count+' Roughcut reviews →</a>'
      + (low ? '<a class="muted" href="'+community+'#working-on">The critical ones, and what we changed</a>' : '')
      + '</div>';
    el.querySelector('.rcRV__row').addEventListener('click', function(e){
      var c = e.target.closest('.rcRV__card'); if (c) openLB(list, c.dataset.rid);
    });
  }

  /* ───────── wall (community page) ───────── */
  function wall(el){
    var issues = [];
    var tag = el.querySelector('script.rcRV-issues');
    if (tag) { try { issues = JSON.parse(tag.textContent) || []; } catch(e) { issues = []; } }
    var good = D.reviews.filter(function(r){ return r.r >= 4; });
    var low = D.reviews.filter(function(r){ return r.r <= 3; });
    var byId = {}; D.reviews.forEach(function(r){ byId[r.id] = r; });
    var M = D.meta, perPage = +(el.dataset.per || 12);
    var photo = good.filter(function(r){ return r.p.length; });

    /* group chips: patterns with at least 2 good reviews, most-reviewed first */
    var gc = {}; good.forEach(function(r){ if (r.g !== 'shop') gc[r.g] = (gc[r.g]||0) + 1; });
    var chipGroups = Object.keys(gc).filter(function(g){ return gc[g] >= 2; }).sort(function(a,b){ return gc[b]-gc[a]; });

    var head = el.querySelector('[data-rv-head]');
    var dist = [5,4,3,2,1].map(function(s){
      var n = M.dist[s] || 0, pct = M.count ? n / M.count * 100 : 0;
      return '<button type="button" class="rcRV__bar" data-star="'+s+'" aria-label="'+n+' reviews with '+s+' stars"><span>'+s+'★</span><i><b style="width:'+pct.toFixed(1)+'%"></b></i><span>'+n+'</span></button>';
    }).join('');
    var fivePct = Math.round((M.dist[5]||0) / M.count * 100);

    el.querySelector('[data-rv-body]').innerHTML =
      '<div class="rcRV__sum">'
      + '<div class="rcRV__score"><span class="rcRV__big">'+M.avg.toFixed(2)+'</span><div>'+stars(Math.round(M.avg))+'<div class="rcRV__cnt">'+M.count+' verified reviews · '+fivePct+'% five star</div></div></div>'
      + '<div class="rcRV__dist">'+dist+'</div>'
      + '<p class="rcRV__sumNote">Every published review is counted here, including the '+low.length+' critical ones. <a href="#working-on" data-go="work">See those and what we changed</a>.</p>'
      + '</div>'
      + '<div class="rcRV__seg" role="tablist" aria-label="Reviews">'
      + '<button type="button" role="tab" aria-selected="true" data-tab="good" id="rv-tab-good" aria-controls="rv-panel-good">Maker reviews<small>'+good.length+' reviews · '+photo.length+' with photos</small></button>'
      + '<button type="button" role="tab" aria-selected="false" data-tab="work" id="rv-tab-work" aria-controls="rv-panel-work">What we\'re working on<small>'+low.length+' reviews · '+issues.length+' fixes</small></button>'
      + '</div>'
      + '<div id="rv-panel-good" role="tabpanel" aria-labelledby="rv-tab-good">'
      +   (photo.length ? '<div class="rcRV__eyebrow">Built by you</div><div class="rcRV__rail">' + photo.map(function(r){
             return '<button type="button" class="rcRV__railItem" data-rid="'+r.id+'"><img loading="lazy" decoding="async" src="'+img(r.p[0],440)+'" alt="Build photo from '+esc(r.n)+'"><span>'+esc(groupName(r.g) && r.g!=='shop' ? groupName(r.g) : r.n)+'</span></button>';
           }).join('') + '</div>' : '')
      +   '<div class="rcRV__chips" role="group" aria-label="Filter reviews">'
      +     '<button type="button" class="rcRV__chip" data-f="all" aria-pressed="true">All<span>'+good.length+'</span></button>'
      +     '<button type="button" class="rcRV__chip" data-f="photos" aria-pressed="false">With photos<span>'+photo.length+'</span></button>'
      +     chipGroups.map(function(g){ return '<button type="button" class="rcRV__chip" data-f="g:'+g+'" aria-pressed="false">'+esc(groupName(g).replace(/^The /,''))+'<span>'+gc[g]+'</span></button>'; }).join('')
      +   '</div>'
      +   '<div class="rcRV__grid" data-grid></div>'
      +   '<button type="button" class="rcRV__moreBtn" data-more>Show more reviews</button>'
      + '</div>'
      + '<div id="rv-panel-work" role="tabpanel" aria-labelledby="rv-tab-work" hidden>' + workPanel() + '</div>';

    /* filtering + paging */
    var grid = el.querySelector('[data-grid]'), moreBtn = el.querySelector('[data-more]');
    var current = good.slice(), shown = 0;
    var featured = function(list){ return list.slice().sort(function(a,b){ return (b.p.length?1:0)-(a.p.length?1:0) || (a.d < b.d ? 1 : -1); }); };
    function render(reset){
      if (reset){ grid.innerHTML = ''; shown = 0; }
      var next = current.slice(shown, shown + perPage);
      grid.insertAdjacentHTML('beforeend', next.map(function(r){ return card(r); }).join(''));
      shown += next.length;
      moreBtn.hidden = shown >= current.length;
      if (!current.length) grid.innerHTML = '<p class="rcRV__empty">No reviews here yet.</p>';
    }
    function filter(f){
      el.querySelectorAll('.rcRV__chip').forEach(function(c){ c.setAttribute('aria-pressed', c.dataset.f === f ? 'true' : 'false'); });
      if (f === 'all') current = featured(good);
      else if (f === 'photos') current = featured(photo);
      else if (f.indexOf('g:') === 0){ var g = f.slice(2); current = featured(good.filter(function(r){ return r.g === g; })); }
      render(true);
    }
    filter('all');
    moreBtn.addEventListener('click', function(){ render(false); });

    /* tabs */
    var tabs = el.querySelectorAll('[role="tab"]');
    function tab(name, scroll){
      tabs.forEach(function(t){ t.setAttribute('aria-selected', t.dataset.tab === name ? 'true' : 'false'); });
      el.querySelector('#rv-panel-good').hidden = name !== 'good';
      el.querySelector('#rv-panel-work').hidden = name !== 'work';
      if (scroll){ var seg = el.querySelector('.rcRV__seg'); var y = seg.getBoundingClientRect().top + scrollY - 90; scrollTo({top: y, behavior: 'smooth'}); }
    }
    tabs.forEach(function(t){ t.addEventListener('click', function(){ tab(t.dataset.tab, false); }); });

    el.addEventListener('click', function(e){
      var go = e.target.closest('[data-go]');
      if (go){ e.preventDefault(); tab(go.dataset.go, true); if (history.replaceState) history.replaceState(null, '', '#working-on'); return; }
      var bar = e.target.closest('.rcRV__bar');
      if (bar){ if (+bar.dataset.star <= 3) tab('work', true); else { tab('good', true); filter('all'); } return; }
      var chip = e.target.closest('.rcRV__chip'); if (chip) return filter(chip.dataset.f);
      var rail = e.target.closest('.rcRV__railItem'); if (rail) return openLB(photo, rail.dataset.rid);
      var c = e.target.closest('.rcRV__card'); if (c && grid.contains(c)) return openLB(current, c.dataset.rid);
    });

    /* deep links: #working-on opens that tab, #reviews just scrolls */
    function fromHash(){
      if (location.hash === '#working-on') { tab('work', false); setTimeout(function(){ el.querySelector('.rcRV__seg').scrollIntoView({block:'start'}); scrollBy(0,-90); }, 60); }
    }
    fromHash(); addEventListener('hashchange', fromHash);

    function workPanel(){
      var team = el.querySelector('template[data-team]');
      var counts = {fixed:0, changed:0, progress:0, listening:0};
      issues.forEach(function(i){ counts[i.status] = (counts[i.status]||0) + 1; });
      var LBL = {fixed:'Fixed', changed:'Changed how we work', progress:'In progress', listening:'Listening'};
      var placed = {};
      var html = (team ? team.innerHTML : '')
        + '<div class="rcRV__tally">' + Object.keys(LBL).filter(function(k){ return counts[k]; }).map(function(k){ return '<span class="rcRV__pill '+k+'">'+counts[k]+' '+LBL[k].toLowerCase()+'</span>'; }).join('') + '</div>'
        + '<div class="rcRV__issues">' + issues.map(function(i){
            var rs = (i.ids || []).map(function(id){ return byId[id]; }).filter(Boolean);
            rs.forEach(function(r){ placed[r.id] = 1; });
            return '<article class="rcRV__issue">'
              + '<span class="rcRV__pill '+esc(i.status)+'">'+esc(LBL[i.status] || i.status)+'</span>'
              + '<h4>'+esc(i.title)+'</h4>'
              + '<div class="rcRV__fixLbl">What we did</div><div class="rcRV__fix">'+(i.body || '')+'</div>'
              + (rs.length ? '<details><summary>Read the '+rs.length+' review'+(rs.length===1?'':'s')+'</summary>' + rs.map(quote).join('') + '</details>' : '')
              + '</article>';
          }).join('') + '</div>';
      /* Any critical review not yet tied to an issue still shows — nothing is hidden. */
      var rest = low.filter(function(r){ return !placed[r.id]; });
      if (rest.length) html += '<article class="rcRV__issue" style="margin-top:12px"><span class="rcRV__pill listening">Listening</span><h4>Other feedback</h4>'
        + '<div class="rcRV__fix"><p>Every one of these has been read. If yours is here and still isn\'t sorted, message us on WhatsApp with your order number.</p></div>'
        + '<details><summary>Read the '+rest.length+' review'+(rest.length===1?'':'s')+'</summary>'+rest.map(quote).join('')+'</details></article>';
      var help = el.querySelector('template[data-help]');
      return html + (help ? help.innerHTML : '');
    }
    function quote(r){
      var pat = groupName(r.g);
      return '<div class="rcRV__quote"><div class="meta">'+stars(r.r)+'<span><b>'+esc(r.n)+'</b></span>'+(pat && r.g!=='shop' ? '<span>'+esc(pat)+'</span>' : '')+'<span>'+fmtDate(r.d)+'</span></div><p class="rcRV__body">'+esc(r.b)+'</p></div>';
    }
  }

  function boot(){
    D = window.RC_REVIEWS; if (!D) return;
    IMG = D.meta.img;
    document.querySelectorAll('[data-rc-reviews]').forEach(function(el){
      if (el.dataset.ready) return; el.dataset.ready = '1';
      try { (el.dataset.mode === 'wall' ? wall : shelf)(el); } catch(e) { console.error('[rc-reviews]', e); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function(){ boot(); });
})();
